import { IsNotEmpty } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IAnalyticsActivityEnum } from '../../../common/enum/analytics-activity/analytics-activity.enum';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { SelfAppAverageSummaryEntity } from '../../../core/domain/entities/scores/self-app-average-summary.entity';
import { GetSelfAppAveragesSummaryResponseDto } from '../../../interface/dtos/scores/get-self-app-averages-summary.response.dto';

export class ISelfAppAverageSummaryEntityPersistenceDto {
  @IsNotEmpty()
  [IAnalyticsActivityEnum.TotalDuration]: string;
  @IsNotEmpty()
  [IAnalyticsActivityEnum.Count]: string;
  @IsNotEmpty()
  [IAnalyticsActivityEnum.TotalCallDuration]: string;
  @IsNotEmpty()
  [IAnalyticsActivityEnum.CallCount]: string;
  @IsNotEmpty()
  [IAnalyticsActivityEnum.DayCount]: string;
  @IsNotEmpty()
  [IAnalyticsActivityEnum.WeekCount]: string;
}

export class SelfAppAverageSummaryEntityMapper
  implements
    Mapper<
      SelfAppAverageSummaryEntity,
      Partial<GetSelfAppAveragesSummaryResponseDto>
    >
{
  toDomain(
    record: ISelfAppAverageSummaryEntityPersistenceDto
  ): SelfAppAverageSummaryEntity {
    return SelfAppAverageSummaryEntityMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfAppAverageSummaryEntityPersistenceDto
  ): SelfAppAverageSummaryEntity {
    const entity = SelfAppAverageSummaryEntity.create({
      totalDuration: Number(record[IAnalyticsActivityEnum.TotalDuration]),
      count: Number(record[IAnalyticsActivityEnum.Count]),
      totalCallDuration: Number(
        record[IAnalyticsActivityEnum.TotalCallDuration]
      ),
      callCount: Number(record[IAnalyticsActivityEnum.CallCount]),
      dayCount: Number(record[IAnalyticsActivityEnum.DayCount]),
      weekCount: Number(record[IAnalyticsActivityEnum.WeekCount]),
    });
    return entity;
  }

  toResponse(
    entity: SelfAppAverageSummaryEntity
  ): Partial<GetSelfAppAveragesSummaryResponseDto> {
    return SelfAppAverageSummaryEntityMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfAppAverageSummaryEntity
  ): Partial<GetSelfAppAveragesSummaryResponseDto> {
    return {
      averageDailyDuration: Math.round(entity.averageDailyDuration),
      averageWeeklyDuration: Math.round(entity.averageWeeklyDuration),
      formattedAverageDailyDuration: formatDuration(
        entity.averageDailyDuration
      ),
      formattedAverageWeeklyDuration: formatDuration(
        entity.averageWeeklyDuration
      ),
      averageDailyInteractions: Math.round(entity.averageDailyInteractions),
      averageWeeklyInteractions: Math.round(entity.averageWeeklyInteractions),
      averageDailyCallInteractions: Math.round(
        entity.averageDailyCallInteractions
      ),
      averageWeeklyCallInteractions: Math.round(
        entity.averageWeeklyCallInteractions
      ),
      averageDailyCallDuration: Math.round(entity.averageDailyCallDuration),
      averageWeeklyCallDuration: Math.round(entity.averageWeeklyCallDuration),
      formattedAverageDailyCallDuration: formatDuration(
        entity.averageDailyCallDuration
      ),
      formattedAverageWeeklyCallDuration: formatDuration(
        entity.averageWeeklyCallDuration
      ),
    };
  }
}
